import { render } from "./AppliedImplantsHospital.vue?vue&type=template&id=0f566ecc&scoped=true"
import script from "./AppliedImplantsHospital.vue?vue&type=script&lang=js"
export * from "./AppliedImplantsHospital.vue?vue&type=script&lang=js"

import "./AppliedImplantsHospital.vue?vue&type=style&index=0&id=0f566ecc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f566ecc"]])

export default __exports__